export default {
  PUBLIC: '1',
  PRIVATE: '2'
}
